import React from 'react';
import { Text } from '@marvelapp/ui';
import { CopyToClipboard, SpecsPanel } from '@marvelapp/ui-internal';
import PanelBox from './PanelBox';
export default function PanelContent(_a) {
    var content = _a.content;
    return (React.createElement(SpecsPanel, { renderLink: function () { return (React.createElement(CopyToClipboard, { bg: "transparent", btnText: "Copy text", color: "marvelDark", fontWeight: 400, px: 0, text: content })); }, title: "Content" },
        React.createElement(PanelBox, null,
            React.createElement(Text, { fontSize: 13, wordBreak: "break-word" }, content))));
}
